export const TaskFilterConst = {
  Year: 'year',
  DateFrom: 'dateFrom',
  DateTo: 'dateTo',
  BaumIdFrom: 'baumIdFrom',
  BaumIdTo: 'baumIdTo',
  Measure: 'measure',
  MeasureId: 'measureId',
  TaskType: 'taskType',
}

export const TaskFilterConstDefault = {
  [TaskFilterConst.Year]: null,
  [TaskFilterConst.DateFrom]: null,
  [TaskFilterConst.DateTo]: null,
  [TaskFilterConst.BaumIdFrom]: null,
  [TaskFilterConst.BaumIdTo]: null,
  [TaskFilterConst.Measure]: null,
  [TaskFilterConst.MeasureId]: null,
  [TaskFilterConst.TaskType]: 2,
}

export const TreeFilterConst = {
  DateFrom: 'dateFrom',
  DateTo: 'dateTo',
  BaumIdFrom: 'baumIdFrom',
  BaumIdTo: 'baumIdTo',
  Color: 'color',
  ActiveTree: 'activeTree',
  WithoutInspection: 'withoutInspection'
}

export const TreeFilterConstDefault = {
  [TreeFilterConst.DateFrom]: null,
  [TreeFilterConst.DateTo]: null,
  [TreeFilterConst.BaumIdFrom]: null,
  [TreeFilterConst.BaumIdTo]: null,
  [TreeFilterConst.Color]: null,
  [TreeFilterConst.ActiveTree]: true,
  [TreeFilterConst.WithoutInspection]: false,
}

export const TreeInspectionConst = {
  Year: 'year',
  Color: 'color',
  TaskType: 'taskType',
  DateFrom: 'dateFrom',
  DateTo: 'dateTo',
  BaumIdFrom: 'baumIdFrom',
  BaumIdTo: 'baumIdTo',
  Measure: 'measure',
  MeasureId: 'measureId'
}

export const TreeInspectionConstDefault = {
  [TreeInspectionConst.Year]: null,
  [TreeInspectionConst.Color]: null,
  [TreeInspectionConst.TaskType]: 2,
  [TaskFilterConst.DateFrom]: null,
  [TaskFilterConst.DateTo]: null,
  [TaskFilterConst.BaumIdFrom]: null,
  [TaskFilterConst.BaumIdTo]: null,
  [TaskFilterConst.Measure]: null,
  [TaskFilterConst.MeasureId]: null
}
